import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { getTranslation, TranslationProvider, utils } from '@resy/ui-kitchen';

import './Menu.scss';

const CLICK_LINK_EVENT = 'click link';

const Menu = ({
  Analytics, isGda, items, showGdaModal, isNonUS, closeMenu,
}) => {
  const gdaModal = () => {
    showGdaModal();
    Analytics.event('Click GDA Menu CTA', {
      category: 'GDA Promotional',
      label: 'Click GDA Menu CTA',
      isUserGda: isGda,
    });
  };

  const handleLinkClick = async (e, item, context) => {
    const label = item.name;
    if (closeMenu) {
      closeMenu();
    }

    if (label) {
      await Analytics.event(CLICK_LINK_EVENT, {
        context,
        value: label,
      });
    }
  };

  const context = utils.getPageContext(window.location.pathname) ?? 'homepage';

  return (
    <ul
      className="Menu"
      role="navigation"
      aria-label={getTranslation({
        translationKey: 'complementary_links',
        fallback: 'Complementary Links',
      })}
    >
      {items.map((item) => {
        if (item.key === 'resyCredit' && isNonUS) return null;
        return (
          <li
            className={cx('Menu__item', {
              divider: item.name === 'divider',
            })}
            key={item.key}
          >
            {item.name !== 'divider' && (
              <TranslationProvider translationKey={item.translationKey}>
                <a
                  className={cx('Menu__item__anchor body color--text-primary family--gt-america-light decoration--none', {
                    active: (window.location.pathname.indexOf(`/${item.path}`) > -1),
                  })}
                  href={!item.isGdaModal ? item.path : '#'}
                  onClick={!item.isGdaModal ? (e) => { handleLinkClick(e, item, context); } : gdaModal}
                >
                  {item.name}
                </a>
              </TranslationProvider>
            )}
          </li>
        );
      })}
    </ul>
  );
};

Menu.propTypes = {
  Analytics: PropTypes.shape({
    event: PropTypes.func,
  }).isRequired,
  isGda: PropTypes.bool.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      activeMatcher: PropTypes.string,
      key: PropTypes.string,
      name: PropTypes.string,
      path: PropTypes.string,
      translationKey: PropTypes.string,
    })
  ).isRequired,
  showGdaModal: PropTypes.func.isRequired,
  isNonUS: PropTypes.bool.isRequired,
  closeMenu: PropTypes.func,
};

Menu.defaultProps = {
  closeMenu: null,
};

Menu.displayName = 'Menu';
export default Menu;
